/* PLEYNE Journal: the plate that reads with a note.
   The plate stays whole and still, and in view while the note is read: beside the text from 768px up;
   on phones it follows the opening and then stays under the header. As each part of the note is read,
   its number on the plate lights up and grows a little. Tap a number to go to that part. */
(function () {
  var root = document.getElementById('jnNote');
  var src = document.getElementById('jnSrc');
  var cfgEl = document.getElementById('jnCfg');
  if (!root || !src || !cfgEl || root.getAttribute('data-ready')) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  root.setAttribute('data-ready', '1');

  var W = 800, H = 1000;
  var PARTS = cfg.parts || {};
  var KEYS = Object.keys(PARTS);
  var mqD = window.matchMedia ? window.matchMedia('(min-width:768px)') : null;
  var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function desk() { return mqD ? mqD.matches : window.innerWidth >= 768; }

  var header = document.getElementById('header');
  var ledger = document.getElementById('jnLedger');
  var bar = document.getElementById('jnBar');
  var onTxt = document.getElementById('jnOn');
  var num = document.getElementById('jnNum');
  var side = document.getElementById('jnSide');
  var layout = root.querySelector('.jn-layout');
  var head = document.getElementById('jnHead');
  var body = document.getElementById('jnBody');
  var parts = [].slice.call(root.querySelectorAll('.jn-part'));
  var hdr = 76;

  function measure() {
    hdr = header ? Math.round(header.getBoundingClientRect().height) : 0;
    if (header && getComputedStyle(header).position !== 'fixed' && getComputedStyle(header).position !== 'sticky') hdr = 0;
    root.style.setProperty('--jn-hdr', hdr + 'px');
  }

  /* phones: the plate follows the opening; from 768px it is the column beside the text */
  function place() {
    if (!side || !layout || !head) return;
    if (desk()) { if (side.parentNode !== layout) layout.insertBefore(side, layout.firstChild); }
    else if (side.previousElementSibling !== head) head.parentNode.insertBefore(side, head.nextSibling);
  }
  function band() { return (!desk() && side) ? side.getBoundingClientRect().height : 0; }

  /* ---------- the plate ---------- */
  var plates = [], cur = 'all';
  function build(host) {
    host.innerHTML = src.innerHTML.replace(/(id="|url\(#)(jn[a-z0-9]+)/g, function (m, a, b) { return a + b + '-1'; });
    var svg = host.querySelector('svg');
    if (!svg) return;
    svg.setAttribute('role', 'img');
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    if (cfg.aria) svg.setAttribute('aria-label', cfg.aria);
    var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    g.setAttribute('class', 'pins');
    var html = '';
    KEYS.forEach(function (p) {
      var c = cfg.pins && cfg.pins[p]; if (!c) return;
      html += '<g class="pin" data-part="' + p + '" transform="translate(' + c[0] + ',' + c[1] + ')" tabindex="0" role="button" aria-label="' + PARTS[p][0] + ', ' + PARTS[p][1] + '">' +
        '<g class="pin-s"><g class="pin-z"><circle class="ring" r="11"></circle><circle class="dot" r="11"></circle><text y="0.5">' + PARTS[p][0] + '</text></g></g></g>';
    });
    g.innerHTML = html;
    var lg = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    lg.setAttribute('class', 'leads');
    var lh = '';
    KEYS.forEach(function (p) {
      var c = cfg.pins && cfg.pins[p]; if (!c) return;
      var a = (cfg.anchors && cfg.anchors[p]) || c;
      lh += '<g class="lead" data-part="' + p + '"><line x1="' + a[0] + '" y1="' + a[1] + '" x2="' + a[0] + '" y2="' + a[1] + '"></line><circle cx="' + a[0] + '" cy="' + a[1] + '" r="3"></circle></g>';
    });
    lg.innerHTML = lh;
    svg.appendChild(lg);
    svg.appendChild(g);
    svg.querySelectorAll('.pin').forEach(function (pin) {
      var go = function (e) { e.preventDefault(); jump(pin.getAttribute('data-part')); };
      pin.addEventListener('click', go);
      pin.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
    });
    plates.push({ svg: svg, cfg: cfg });
    markOn(svg, cur);
  }

  /* light up the number, lines, helpers and zones that belong to a part */
  function markOn(svg, on) {
    svg.setAttribute('data-on', on);
    svg.querySelectorAll('[data-f],[data-h]').forEach(function (el) {
      var k = (el.getAttribute('data-f') || el.getAttribute('data-h') || '').split(' ');
      el.classList.toggle('is-on', k.indexOf(on) > -1);
    });
    svg.querySelectorAll('.pin, .lead').forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-part') === on); });
  }

  /* keep the numbers the same size on screen, whatever size the plate is drawn.
     Phones: the plate is small, so the numbers stand in the free space beside it, each with a fine
     leader line to its point on the drawing, and the drawing itself stays clear. */
  function sizePins(rec) {
    var svg = rec.svg, pc = rec.cfg || {};
    var r = svg.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var s = Math.min(r.width / W, r.height / H);
    var phone = !desk();
    var gut = Math.max(0, (r.width / s - W) / 2);         /* plate units free on each side */
    var besides = phone && gut * s >= 52;
    svg.classList.toggle('pins-side', besides);
    svg.setAttribute('viewBox', besides ? (-gut).toFixed(1) + ' 0 ' + (W + 2 * gut).toFixed(1) + ' ' + H : '0 0 ' + W + ' ' + H);
    var k = (phone ? 1 : 1.18) / s, R = 11 / s;
    var items = [].slice.call(svg.querySelectorAll('.pin')).map(function (pin) {
      var p = pin.getAttribute('data-part'), c = (pc.pins || {})[p] || [0, 0], a = (pc.anchors || {})[p] || c;
      return { pin: pin, p: p, c: c, a: a, left: a[0] < W / 2, x: c[0], y: c[1] };
    });
    if (besides) {
      var off = (11 + 14) / s, D = (22 + 8) / s, top = R + 10 / s, bot = H - R - 10 / s;
      [true, false].forEach(function (L) {
        var col = items.filter(function (it) { return it.left === L; }).sort(function (u, v) { return u.a[1] - v.a[1]; });
        col.forEach(function (it, i) { it.x = L ? -off : W + off; it.y = Math.max(it.a[1], top, i ? col[i - 1].y + D : top); });
        for (var i = col.length - 1; i >= 0; i--) { var lim = i === col.length - 1 ? bot : col[i + 1].y - D; if (col[i].y > lim) col[i].y = lim; }
      });
    }
    items.forEach(function (it) {
      it.pin.setAttribute('transform', 'translate(' + it.x.toFixed(1) + ',' + it.y.toFixed(1) + ')');
      var ps = it.pin.querySelector('.pin-s'); if (ps) ps.setAttribute('transform', 'scale(' + k.toFixed(4) + ')');
      var lead = svg.querySelector('.lead[data-part="' + it.p + '"]');
      if (!lead) return;
      var ln = lead.querySelector('line'), dot = lead.querySelector('circle');
      ln.setAttribute('x1', (it.left ? it.x + R : it.x - R).toFixed(1)); ln.setAttribute('y1', it.y.toFixed(1));
      ln.setAttribute('x2', it.a[0]); ln.setAttribute('y2', it.a[1]);
      dot.setAttribute('r', (2.6 / s).toFixed(2));
    });
  }

  /* ---------- reading position ---------- */
  var lastOn = null, lastActive, lock = null;
  function onScroll() {
    var vh = window.innerHeight;
    var top = hdr + band();
    var line = top + (vh - top) * 0.3;
    var active = null;
    parts.forEach(function (p) { if (p.getBoundingClientRect().top < line) active = p; });
    if (lock) active = document.getElementById('p-' + lock) || active;
    var on = active ? active.getAttribute('data-part') : 'all';
    var b = body.getBoundingClientRect();
    var prog = Math.min(1, Math.max(0, (line - b.top) / Math.max(1, b.height)));
    if (bar) bar.style.width = (prog * 100).toFixed(1) + '%';
    if (ledger) ledger.classList.toggle('show', head.getBoundingClientRect().bottom < hdr);
    if (on === lastOn && active === lastActive) return;
    lastOn = on; lastActive = active; cur = on;
    var label = active ? active.getAttribute('data-label') : '';
    if (onTxt) onTxt.textContent = active ? label : onTxt.getAttribute('data-title') || onTxt.textContent;
    if (num) num.textContent = active ? label.split(' · ')[0] : (KEYS[0] ? PARTS[KEYS[0]][0] : '01');
    plates.forEach(function (rec) { markOn(rec.svg, on); });
  }

  function jump(part) {
    var el = document.getElementById('p-' + part);
    if (!el) return;
    lock = part;
    var y = window.pageYOffset + el.getBoundingClientRect().top - hdr - (desk() ? 52 : band() + 14);
    window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
    lastOn = null; onScroll();
  }

  /* ---------- wiring ---------- */
  if (onTxt) onTxt.setAttribute('data-title', onTxt.textContent);

  /* scrolling by hand hands the highlight back to the reading position */
  function release() { if (lock) { lock = null; onScroll(); } }
  window.addEventListener('wheel', release, { passive: true });
  window.addEventListener('touchmove', release, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].indexOf(e.key) > -1 && !(e.target.closest && e.target.closest('.pin'))) release();
  });

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; onScroll(); });
  }, { passive: true });

  var rz;
  function onResize() { measure(); place(); plates.forEach(sizePins); lastOn = null; onScroll(); }
  window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(onResize, 80); });
  if (mqD) { if (mqD.addEventListener) mqD.addEventListener('change', onResize); else if (mqD.addListener) mqD.addListener(onResize); }
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(function () { plates.forEach(sizePins); });
    root.querySelectorAll('.jn-side .jn-plate').forEach(function (h) { ro.observe(h); });
  }

  measure();
  place();
  root.querySelectorAll('.jn-side [data-follow]').forEach(build);
  requestAnimationFrame(function () { plates.forEach(sizePins); onScroll(); });
})();

/* PLEYNE Journal list: on desktop, the plate of the note under the cursor shows in the frame. */
(function () {
  var ix = document.getElementById('jnIndex');
  if (!ix || ix.getAttribute('data-ready')) return;
  ix.setAttribute('data-ready', '1');
  var header = document.getElementById('header');
  function measure() {
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    if (header && getComputedStyle(header).position !== 'fixed' && getComputedStyle(header).position !== 'sticky') h = 0;
    ix.style.setProperty('--jn-hdr', h + 'px');
  }
  measure();
  window.addEventListener('resize', measure);
  var rows = [].slice.call(ix.querySelectorAll('.jx-row'));
  var imgs = [].slice.call(ix.querySelectorAll('.jx-fig img'));
  var cap = document.getElementById('jxCap');
  function show(row) {
    var i = row.getAttribute('data-i');
    var hasImg = imgs.some(function (im) { return im.getAttribute('data-i') === i; });
    if (!hasImg) return;
    rows.forEach(function (r) { r.classList.toggle('on', r === row); });
    imgs.forEach(function (im) { im.classList.toggle('on', im.getAttribute('data-i') === i); });
    if (cap) {
      var no = row.getAttribute('data-no');
      var t = row.querySelector('.jx-t');
      cap.textContent = '';
      if (no) { var b = document.createElement('b'); b.textContent = 'Note ' + no; cap.appendChild(b); }
      cap.appendChild(document.createTextNode(t ? t.textContent : ''));
    }
  }
  rows.forEach(function (r) {
    r.addEventListener('mouseenter', function () { show(r); });
    r.addEventListener('focus', function () { show(r); });
  });
})();
